module.exports = __webpack_public_path__ + "static/media/SL 21.185b446d.mp3";